module.exports = __webpack_public_path__ + "fonts/75ee419.woff";